// import React from "react";
// import { useLocation, useParams, useNavigate } from "react-router-dom";
// import {
//   FaShippingFast,
//   FaMoneyCheckAlt,
//   FaBoxOpen,
//   FaArrowLeft,
//   FaCheckCircle,
// } from "react-icons/fa";

// const OrderDetails = () => {
//   const { state } = useLocation();
//   const { orderId } = useParams();
//   const navigate = useNavigate();
//   const order = state?.order;

//   if (!order) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="text-center py-10">
//           <div className="text-red-500 text-5xl mb-4">
//             <FaCheckCircle />
//           </div>
//           <h2 className="text-2xl font-bold text-gray-800 mb-2">
//             Order Not Found
//           </h2>
//           <p className="text-gray-600 mb-6">
//             The order you're looking for doesn't exist or has been removed.
//           </p>
//           <button
//             onClick={() => navigate("/YourOrders")}
//             className="px-6 py-3 bg-[#82b016] hover:bg-[#6fa010] text-white font-medium rounded-lg transition-colors duration-200"
//           >
//             Back to Orders
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const orderDate = new Date(order.createDate).toLocaleDateString();
//   const shipping = 40;
//   const grandTotal = order.total + shipping;

//   // Extract customer information
//   const billingPerson = order.billingPerson || {};
//   const customer = order.customer || {};

//   // Status badge styling
//   const getStatusBadge = () => {
//     const payment = order.paymentStatus;
//     const fulfillment = order.fulfillmentStatus;

//     if (payment === "PAID" && fulfillment === "DELIVERED") {
//       return {
//         text: "Delivered",
//         bgColor: "bg-green-100",
//         textColor: "text-green-800",
//         borderColor: "border-green-200",
//       };
//     } else if (payment === "PAID" && fulfillment === "SHIPPED") {
//       return {
//         text: "Shipped",
//         bgColor: "bg-blue-100",
//         textColor: "text-blue-800",
//         borderColor: "border-blue-200",
//       };
//     } else if (payment === "AWAITING_PAYMENT") {
//       return {
//         text: "Awaiting Payment",
//         bgColor: "bg-yellow-100",
//         textColor: "text-yellow-800",
//         borderColor: "border-yellow-200",
//       };
//     } else if (payment === "CANCELLED") {
//       return {
//         text: "Cancelled",
//         bgColor: "bg-red-100",
//         textColor: "text-red-800",
//         borderColor: "border-red-200",
//       };
//     } else {
//       return {
//         text: "Processing",
//         bgColor: "bg-purple-100",
//         textColor: "text-purple-800",
//         borderColor: "border-purple-200",
//       };
//     }
//   };

//   const statusBadge = getStatusBadge();

//   return (
//     <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen py-10 px-4 md:px-0">
//       <div className="max-w-7xl mx-auto">
//         {/* Header with Back Button */}
//         <div className="flex items-center justify-between mb-6">
//           <button
//             onClick={() => navigate("/YourOrders")}
//             className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium"
//           >
//             <FaArrowLeft /> Back to Orders
//           </button>
//           <span
//             className={`px-4 py-1 rounded-full text-sm font-medium border ${statusBadge.bgColor} ${statusBadge.textColor} ${statusBadge.borderColor}`}
//           >
//             {statusBadge.text}
//           </span>
//         </div>

//         {/* Order Summary Header */}
//         <div className="bg-gradient-to-r from-[#82b016] to-green-600 text-white rounded-xl shadow-lg py-3 px-4 mb-8 border border-gray-100">
//           <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//             <div>
//               <h1 className="text-3xl font-bold text-white mb-2">
//                 Order Details
//               </h1>
//               <p className="text-gray-100">
//                 Order placed on{" "}
//                 <span className="font-semibold">{orderDate}</span> • Order #
//                 <span className="font-semibold">{orderId}</span>
//               </p>
//             </div>
//             <div className="bg-gradient-to-r from-gray-50 to-gray-100 text-gray-700 px-6 py-3 rounded-lg shadow">
//               <p className="text-sm">Total Amount</p>
//               <p className="text-2xl font-bold">₹{grandTotal}</p>
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
//           {/* Shipping Info */}
//           <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
//             <div className="flex items-center mb-4">
//               <div className="bg-lime-500 p-3 rounded-lg mr-4">
//                 <FaShippingFast className="text-white text-xl" />
//               </div>
//               <h2 className="text-xl font-bold text-gray-800">
//                 Shipping Information
//               </h2>
//             </div>
//             <div className="space-y-2 text-gray-600">
//               <p className="font-medium">
//                 {billingPerson.name ||
//                   `${customer.firstName || ""} ${
//                     customer.lastName || ""
//                   }`.trim() ||
//                   "N/A"}
//               </p>
//               <p>{billingPerson.street || customer.address1 || "N/A"}</p>
//               <p>
//                 {billingPerson.city || customer.city || "N/A"},{" "}
//                 {billingPerson.postalCode || customer.postalCode || "N/A"}
//               </p>
//               <p>{billingPerson.countryName || customer.country || "N/A"}</p>
//               {customer.mobile && <p>Phone: {customer.mobile}</p>}
//             </div>
//           </div>

//           {/* Payment Info */}
//           <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
//             <div className="flex items-center mb-4">
//               <div className="bg-green-600 p-3 rounded-lg mr-4">
//                 <FaMoneyCheckAlt className="text-white text-xl" />
//               </div>
//               <h2 className="text-xl font-bold text-gray-800">
//                 Payment Method
//               </h2>
//             </div>
//             <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
//               <span className="text-gray-600">Payment Method</span>
//               <span className="font-medium">
//                 {order.paymentMethod || "N/A"}
//               </span>
//             </div>
//             <div className="mt-4 text-sm text-gray-500">
//               <p className="flex justify-between py-2 border-b border-gray-100">
//                 <span>Subtotal</span>
//                 <span>₹{order.total.toFixed(2)}</span>
//               </p>
//               <p className="flex justify-between py-2 border-b border-gray-100">
//                 <span>Shipping</span>
//                 <span>₹{shipping}</span>
//               </p>
//               <p className="flex justify-between py-2 font-bold">
//                 <span>Total</span>
//                 <span className="text-[#82b016]">₹{grandTotal.toFixed(2)}</span>
//               </p>
//             </div>
//           </div>

//           {/* Order Summary */}
//           <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
//             <div className="flex items-center mb-4">
//               <div className="bg-amber-500 p-3 rounded-lg mr-4">
//                 <FaBoxOpen className="text-white text-xl" />
//               </div>
//               <h2 className="text-xl font-bold text-gray-800">Order Summary</h2>
//             </div>
//             <div className="space-y-3">
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Order Status</span>
//                 <span
//                   className={`px-2 py-1 rounded text-xs font-medium ${statusBadge.bgColor} ${statusBadge.textColor}`}
//                 >
//                   {order.fulfillmentStatus?.replace("_", " ") || "N/A"}
//                 </span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Payment Status</span>
//                 <span className="font-medium">
//                   {order.paymentStatus?.replace("_", " ") || "N/A"}
//                 </span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Items</span>
//                 <span className="font-medium">{order.items?.length || 0}</span>
//               </div>
//               <div className="flex justify-between">
//                 <span className="text-gray-600">Order ID</span>
//                 <span className="font-medium">{orderId}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Product List */}
//         <div className="bg-white rounded-xl shadow-md p-5 border border-gray-200">
//           <h2 className="text-2xl font-bold text-gray-800 mb-6">
//             Items in Your Order
//           </h2>
//           <div className="space-y-6">
//             {order.items.map((item) => (
//               <div
//                 key={item.id}
//                 className="flex flex-col sm:flex-row gap-6 p-4 border border-gray-300 rounded-lg hover:shadow-md transition-shadow duration-200"
//               >
//                 {/* Product Image */}
//                 <img
//                   src={item.imageUrl || "/assets/No-img.png.png"}
//                   alt={item.name}
//                   className="w-full sm:w-32 h-32 object-cover rounded-lg border border-gray-200"
//                 />

//                 {/* Product Info */}
//                 <div className="flex-1">
//                   <div className="flex flex-col md:flex-row justify-between gap-4">
//                     <div>
//                       <h3 className="text-xl font-bold text-gray-800 mb-1">
//                         {item.name}
//                       </h3>
//                       <p className="text-gray-600 mb-2">Sold by: Your Store</p>
//                       <div className="flex flex-wrap gap-2 mb-3">
//                         <span className="px-2 py-1 bg-gray-100 text-gray-600 text-sm rounded">
//                           Qty: {item.quantity}
//                         </span>
//                         <span className="px-2 py-1 bg-gray-100 text-gray-600 text-sm rounded">
//                           Price: ₹{item.price}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="flex items-start">
//                       <p className="text-xl font-bold text-[#82b016]">
//                         ₹{item.price * item.quantity}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderDetails;

import React, { useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaShippingFast,
  FaMoneyCheckAlt,
  FaBoxOpen,
  FaArrowLeft,
  FaCheckCircle,
  FaTimesCircle,
  FaEdit,
  FaTruck,
} from "react-icons/fa";
import { ECWID_STORE_ID, ECWID_ACCESS_TOKEN } from "../config/EcwidConfig";

const OrderDetails = () => {
  const { state } = useLocation();
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(state?.order);
  const [updateMessage, setUpdateMessage] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [newAddress, setNewAddress] = useState({
    name: "",
    street: "",
    city: "",
    countryCode: "",
    postalCode: "",
    stateOrProvinceCode: "",
    phone: "",
  });

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center py-10">
          <div className="text-red-500 text-5xl mb-4">
            <FaCheckCircle />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Order Not Found
          </h2>
          <p className="text-gray-600 mb-6">
            The order you're looking for doesn't exist or has been removed.
          </p>
          <button
            onClick={() => navigate("/YourOrders")}
            className="px-6 py-3 bg-[#82b016] hover:bg-[#6fa010] text-white font-medium rounded-lg transition-colors duration-200"
          >
            Back to Orders
          </button>
        </div>
      </div>
    );
  }

  const orderDate = new Date(order.createDate).toLocaleDateString();
  const shipping = 40;
  const grandTotal = order.total + shipping;

  // Extract customer information
  const billingPerson = order.billingPerson || {};
  const customer = order.customer || {};

  // Status badge styling
  const getStatusBadge = () => {
    const payment = order.paymentStatus;
    const fulfillment = order.fulfillmentStatus;

    if (payment === "PAID" && fulfillment === "DELIVERED") {
      return {
        text: "Delivered",
        bgColor: "bg-green-100",
        textColor: "text-green-800",
        borderColor: "border-green-200",
      };
    } else if (payment === "PAID" && fulfillment === "SHIPPED") {
      return {
        text: "Shipped",
        bgColor: "bg-blue-100",
        textColor: "text-blue-800",
        borderColor: "border-blue-200",
      };
    } else if (payment === "AWAITING_PAYMENT") {
      return {
        text: "Awaiting Payment",
        bgColor: "bg-yellow-100",
        textColor: "text-yellow-800",
        borderColor: "border-yellow-200",
      };
    } else if (payment === "CANCELLED") {
      return {
        text: "Cancelled",
        bgColor: "bg-red-100",
        textColor: "text-red-800",
        borderColor: "border-red-200",
      };
    } else {
      return {
        text: "Processing",
        bgColor: "bg-purple-100",
        textColor: "text-purple-800",
        borderColor: "border-purple-200",
      };
    }
  };

  const statusBadge = getStatusBadge();

  // Check if order can be cancelled
  const canCancelOrder = () => {
    const cancellableStatuses = [
      "AWAITING_PAYMENT",
      "PAID",
      "AWAITING_PROCESSING",
    ];
    return (
      cancellableStatuses.includes(order.paymentStatus) ||
      cancellableStatuses.includes(order.fulfillmentStatus)
    );
  };

  // Function to fetch updated order data
  const fetchUpdatedOrder = async () => {
    try {
      const response = await axios.get(
        `https://app.ecwid.com/api/v3/${ECWID_STORE_ID}/orders/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${ECWID_ACCESS_TOKEN}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching updated order:", error);
      throw error;
    }
  };

  // Function to update order (cancel or modify shipping address)
  const updateOrder = async (updateData, actionType) => {
    setIsUpdating(true);
    setUpdateMessage("");

    try {
      const response = await axios.put(
        `https://app.ecwid.com/api/v3/${ECWID_STORE_ID}/orders/${orderId}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${ECWID_ACCESS_TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.updateCount > 0) {
        setUpdateMessage(`${actionType} successful!`);
        // Fetch the updated order data from the API
        try {
          const updatedOrder = await fetchUpdatedOrder();
          setOrder(updatedOrder);
        } catch (fetchError) {
          // If we can't fetch the updated order, at least show a success message
          console.warn("Could not fetch updated order data:", fetchError);
        }
      } else {
        setUpdateMessage(
          `Failed to ${actionType.toLowerCase()}. Please try again.`
        );
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()}:`, error);
      setUpdateMessage(
        `Error ${actionType.toLowerCase()}: ${
          error.response?.data?.errorMessage || error.message
        }`
      );
    } finally {
      setIsUpdating(false);
      // Hide the address form after successful update
      if (actionType === "Shipping address update") {
        setShowAddressForm(false);
      }
    }
  };

  // Function to cancel an order
  const cancelOrder = async () => {
    if (!canCancelOrder()) {
      setUpdateMessage("This order cannot be cancelled at its current status.");
      return;
    }

    if (window.confirm("Are you sure you want to cancel this order?")) {
      await updateOrder(
        {
          paymentStatus: "CANCELLED",
          fulfillmentStatus: "WILL_NOT_DELIVER",
        },
        "Cancellation"
      );
    }
  };

  // Function to update shipping address
  const updateShippingAddress = async () => {
    if (
      !newAddress.name ||
      !newAddress.street ||
      !newAddress.city ||
      !newAddress.countryCode ||
      !newAddress.postalCode
    ) {
      setUpdateMessage("Please fill in all required address fields.");
      return;
    }

    await updateOrder(
      {
        shippingPerson: newAddress,
      },
      "Shipping address update"
    );
  };

  // Handle address form input changes
  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setNewAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Initialize address form with current shipping info
  const initializeAddressForm = () => {
    setNewAddress({
      name:
        billingPerson.name ||
        `${customer.firstName || ""} ${customer.lastName || ""}`.trim() ||
        "",
      street: billingPerson.street || customer.address1 || "",
      city: billingPerson.city || customer.city || "",
      countryCode: billingPerson.countryCode || "US", // Default to US
      postalCode: billingPerson.postalCode || customer.postalCode || "",
      stateOrProvinceCode:
        billingPerson.stateOrProvinceCode || customer.state || "",
      phone: billingPerson.phone || customer.mobile || "",
    });
    setShowAddressForm(true);
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen py-10 px-4 md:px-0">
      <div className="max-w-7xl mx-auto">
        {/* Header with Back Button */}
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={() => navigate("/YourOrders")}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-medium"
          >
            <FaArrowLeft /> Back to Orders
          </button>
          <span
            className={`px-4 py-1 rounded-full text-sm font-medium border ${statusBadge.bgColor} ${statusBadge.textColor} ${statusBadge.borderColor}`}
          >
            {statusBadge.text}
          </span>
        </div>

        {/* Update Message */}
        {updateMessage && (
          <div
            className={`mb-4 p-4 rounded-lg ${
              updateMessage.includes("Error") ||
              updateMessage.includes("cannot")
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {updateMessage}
          </div>
        )}

        {/* Order Summary Header */}
        <div className="bg-gradient-to-r from-[#82b016] to-green-600 text-white rounded-xl shadow-lg py-3 px-4 mb-8 border border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Order Details
              </h1>
              <p className="text-gray-100">
                Order placed on{" "}
                <span className="font-semibold">{orderDate}</span> • Order #
                <span className="font-semibold">{orderId}</span>
              </p>
            </div>
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 text-gray-700 px-6 py-3 rounded-lg shadow">
              <p className="text-sm">Total Amount</p>
              <p className="text-2xl font-bold">₹{grandTotal}</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mb-6 flex flex-wrap gap-3">
          {canCancelOrder() && (
            <button
              onClick={cancelOrder}
              disabled={isUpdating}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                isUpdating
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-red-500 hover:bg-red-600 text-white"
              }`}
            >
              {isUpdating ? (
                <>
                  <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                  Cancelling...
                </>
              ) : (
                <>
                  <FaTimesCircle /> Cancel Order
                </>
              )}
            </button>
          )}

          <button
            onClick={initializeAddressForm}
            disabled={isUpdating}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
              isUpdating
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-yellow-500 hover:bg-yellow-600 text-white"
            }`}
          >
            {isUpdating ? (
              <>
                <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                Updating...
              </>
            ) : (
              <>
                <FaEdit /> Update Shipping Address
              </>
            )}
          </button>

          <button
            onClick={() => setShowTrackingModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors duration-200"
          >
            <FaTruck /> Track Progress
          </button>
        </div>

        {/* Update Shipping Address Form */}
        {showAddressForm && (
          <div className="bg-white rounded-xl shadow-lg p-6 mb-8 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              Update Shipping Address
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Full Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={newAddress.name}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Street Address *
                </label>
                <input
                  type="text"
                  name="street"
                  value={newAddress.street}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  City *
                </label>
                <input
                  type="text"
                  name="city"
                  value={newAddress.city}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Country Code *
                </label>
                <input
                  type="text"
                  name="countryCode"
                  value={newAddress.countryCode}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                  placeholder="e.g., US, CA, UK"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Postal Code *
                </label>
                <input
                  type="text"
                  name="postalCode"
                  value={newAddress.postalCode}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  State/Province
                </label>
                <input
                  type="text"
                  name="stateOrProvinceCode"
                  value={newAddress.stateOrProvinceCode}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone Number
                </label>
                <input
                  type="text"
                  name="phone"
                  value={newAddress.phone}
                  onChange={handleAddressChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#82b016]"
                />
              </div>
            </div>
            <div className="flex gap-3 mt-4">
              <button
                onClick={updateShippingAddress}
                disabled={isUpdating}
                className={`px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                  isUpdating
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-[#82b016] hover:bg-[#6fa010] text-white"
                }`}
              >
                {isUpdating ? "Updating..." : "Save Address"}
              </button>
              <button
                onClick={() => setShowAddressForm(false)}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg font-medium transition-colors duration-200"
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          {/* Shipping Info */}
          <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
            <div className="flex items-center mb-4">
              <div className="bg-lime-500 p-3 rounded-lg mr-4">
                <FaShippingFast className="text-white text-xl" />
              </div>
              <h2 className="text-xl font-bold text-gray-800">
                Shipping Information
              </h2>
            </div>
            <div className="space-y-2 text-gray-600">
              {/* Updated to use the current order data which will reflect changes */}
              <p className="font-medium">
                {order.shippingPerson?.name ||
                  order.billingPerson?.name ||
                  `${customer.firstName || ""} ${
                    customer.lastName || ""
                  }`.trim() ||
                  "N/A"}
              </p>
              <p>
                {order.shippingPerson?.street ||
                  order.billingPerson?.street ||
                  customer.address1 ||
                  "N/A"}
              </p>
              <p>
                {order.shippingPerson?.city ||
                  order.billingPerson?.city ||
                  customer.city ||
                  "N/A"}
                ,{" "}
                {order.shippingPerson?.postalCode ||
                  order.billingPerson?.postalCode ||
                  customer.postalCode ||
                  "N/A"}
              </p>
              <p>
                {order.shippingPerson?.countryName ||
                  order.billingPerson?.countryName ||
                  customer.country ||
                  "N/A"}
              </p>
              {(order.shippingPerson?.phone ||
                order.billingPerson?.phone ||
                customer.mobile) && (
                <p>
                  Phone:{" "}
                  {order.shippingPerson?.phone ||
                    order.billingPerson?.phone ||
                    customer.mobile}
                </p>
              )}
            </div>
          </div>

          {/* Payment Info */}
          <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
            <div className="flex items-center mb-4">
              <div className="bg-green-600 p-3 rounded-lg mr-4">
                <FaMoneyCheckAlt className="text-white text-xl" />
              </div>
              <h2 className="text-xl font-bold text-gray-800">
                Payment Method
              </h2>
            </div>
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <span className="text-gray-600">Payment Method</span>
              <span className="font-medium">
                {order.paymentMethod || "N/A"}
              </span>
            </div>
            <div className="mt-4 text-sm text-gray-500">
              <p className="flex justify-between py-2 border-b border-gray-100">
                <span>Subtotal</span>
                <span>₹{order.total.toFixed(2)}</span>
              </p>
              <p className="flex justify-between py-2 border-b border-gray-100">
                <span>Shipping</span>
                <span>₹{shipping}</span>
              </p>
              <p className="flex justify-between py-2 font-bold">
                <span>Total</span>
                <span className="text-[#82b016]">₹{grandTotal.toFixed(2)}</span>
              </p>
            </div>
          </div>

          {/* Order Summary */}
          <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
            <div className="flex items-center mb-4">
              <div className="bg-amber-500 p-3 rounded-lg mr-4">
                <FaBoxOpen className="text-white text-xl" />
              </div>
              <h2 className="text-xl font-bold text-gray-800">Order Summary</h2>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">Order Status</span>
                <span
                  className={`px-2 py-1 rounded text-xs font-medium ${statusBadge.bgColor} ${statusBadge.textColor}`}
                >
                  {order.fulfillmentStatus?.replace("_", " ") || "N/A"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Payment Status</span>
                <span className="font-medium">
                  {order.paymentStatus?.replace("_", " ") || "N/A"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Items</span>
                <span className="font-medium">{order.items?.length || 0}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Order ID</span>
                <span className="font-medium">{orderId}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Product List */}
        <div className="bg-white rounded-xl shadow-md p-5 border border-gray-200">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Items in Your Order
          </h2>
          <div className="space-y-6">
            {order.items.map((item) => (
              <div
                key={item.id}
                className="flex flex-col sm:flex-row gap-6 p-4 border border-gray-300 rounded-lg hover:shadow-md transition-shadow duration-200"
              >
                {/* Product Image */}
                <img
                  src={item.imageUrl || "/assets/No-img.png.png"}
                  alt={item.name}
                  className="w-full sm:w-32 h-32 object-cover rounded-lg border border-gray-200"
                />

                {/* Product Info */}
                <div className="flex-1">
                  <div className="flex flex-col md:flex-row justify-between gap-4">
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-1">
                        {item.name}
                      </h3>
                      <p className="text-gray-600 mb-2">Sold by: Your Store</p>
                      <div className="flex flex-wrap gap-2 mb-3">
                        <span className="px-2 py-1 bg-gray-100 text-gray-600 text-sm rounded">
                          Qty: {item.quantity}
                        </span>
                        <span className="px-2 py-1 bg-gray-100 text-gray-600 text-sm rounded">
                          Price: ₹{item.price}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <p className="text-xl font-bold text-[#82b016]">
                        ₹{item.price * item.quantity}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tracking Modal */}
      {showTrackingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">
                  Order Tracking
                </h3>
                <button
                  onClick={() => setShowTrackingModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FaTimesCircle className="text-2xl" />
                </button>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-700 mb-2">
                  Order #{orderId}
                </h4>
                <p className="text-gray-600">Placed on {orderDate}</p>
              </div>

              {/* Tracking Status */}
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-700 mb-4">
                  Tracking Status
                </h4>
                <div className="relative">
                  {/* Timeline */}
                  <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-300"></div>

                  {/* Order Placed */}
                  <div className="flex mb-8">
                    <div className="flex flex-col items-center mr-4">
                      <div className="w-8 h-8 rounded-full bg-[#82b016] flex items-center justify-center">
                        <FaCheckCircle className="text-white text-sm" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h5 className="font-semibold text-gray-800">
                        Order Placed
                      </h5>
                      <p className="text-gray-600 text-sm">
                        Your order has been received
                      </p>
                      <p className="text-gray-500 text-xs mt-1">
                        {new Date(order.createDate).toLocaleString()}
                      </p>
                    </div>
                  </div>

                  {/* Payment Status */}
                  <div className="flex mb-8">
                    <div className="flex flex-col items-center mr-4">
                      <div
                        className={`w-8 h-8 rounded-full ${
                          order.paymentStatus === "PAID"
                            ? "bg-[#82b016]"
                            : "bg-gray-300"
                        } flex items-center justify-center`}
                      >
                        {order.paymentStatus === "PAID" ? (
                          <FaCheckCircle className="text-white text-sm" />
                        ) : (
                          <div className="w-3 h-3 rounded-full bg-white"></div>
                        )}
                      </div>
                    </div>
                    <div className="flex-1">
                      <h5 className="font-semibold text-gray-800">
                        {order.paymentStatus === "PAID"
                          ? "Payment Confirmed"
                          : "Payment Processing"}
                      </h5>
                      <p className="text-gray-600 text-sm">
                        {order.paymentStatus === "PAID"
                          ? "Payment has been successfully processed"
                          : "Waiting for payment confirmation"}
                      </p>
                      {order.paymentStatus === "PAID" && (
                        <p className="text-gray-500 text-xs mt-1">
                          {new Date(order.createDate).toLocaleString()}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Order Processing */}
                  <div className="flex mb-8">
                    <div className="flex flex-col items-center mr-4">
                      <div
                        className={`w-8 h-8 rounded-full ${
                          order.fulfillmentStatus !== "AWAITING_PROCESSING" &&
                          order.paymentStatus !== "CANCELLED"
                            ? "bg-[#82b016]"
                            : "bg-gray-300"
                        } flex items-center justify-center`}
                      >
                        {order.fulfillmentStatus !== "AWAITING_PROCESSING" &&
                        order.paymentStatus !== "CANCELLED" ? (
                          <FaCheckCircle className="text-white text-sm" />
                        ) : (
                          <div className="w-3 h-3 rounded-full bg-white"></div>
                        )}
                      </div>
                    </div>
                    <div className="flex-1">
                      <h5 className="font-semibold text-gray-800">
                        {order.paymentStatus === "CANCELLED"
                          ? "Order Cancelled"
                          : order.fulfillmentStatus === "AWAITING_PROCESSING"
                          ? "Order Processing"
                          : order.fulfillmentStatus === "PROCESSING"
                          ? "Order Being Processed"
                          : "Order Processed"}
                      </h5>
                      <p className="text-gray-600 text-sm">
                        {order.paymentStatus === "CANCELLED"
                          ? "Your order has been cancelled"
                          : order.fulfillmentStatus === "AWAITING_PROCESSING"
                          ? "We are preparing your order"
                          : order.fulfillmentStatus === "PROCESSING"
                          ? "Your order is being prepared for shipment"
                          : "Your order has been processed and is ready for shipping"}
                      </p>
                    </div>
                  </div>

                  {/* Shipped */}
                  <div className="flex mb-8">
                    <div className="flex flex-col items-center mr-4">
                      <div
                        className={`w-8 h-8 rounded-full ${
                          order.fulfillmentStatus === "SHIPPED" ||
                          order.fulfillmentStatus === "DELIVERED" ||
                          order.paymentStatus !== "CANCELLED"
                            ? "bg-[#82b016]"
                            : "bg-gray-300"
                        } flex items-center justify-center`}
                      >
                        {order.fulfillmentStatus === "SHIPPED" ||
                        order.fulfillmentStatus === "DELIVERED" ||
                        order.paymentStatus !== "CANCELLED" ? (
                          <FaCheckCircle className="text-white text-sm" />
                        ) : (
                          <div className="w-3 h-3 rounded-full bg-white"></div>
                        )}
                      </div>
                    </div>
                    <div className="flex-1">
                      <h5 className="font-semibold text-gray-800">
                        {order.paymentStatus === "CANCELLED"
                          ? "Order Cancelled"
                          : order.fulfillmentStatus === "SHIPPED"
                          ? "Order Shipped"
                          : order.fulfillmentStatus === "DELIVERED"
                          ? "Order Delivered"
                          : "Not Yet Shipped"}
                      </h5>
                      <p className="text-gray-600 text-sm">
                        {order.paymentStatus === "CANCELLED"
                          ? "Your order has been cancelled and will not be shipped"
                          : order.fulfillmentStatus === "SHIPPED"
                          ? "Your order has been shipped"
                          : order.fulfillmentStatus === "DELIVERED"
                          ? "Your order has been delivered successfully"
                          : "Your order is being prepared for shipping"}
                      </p>
                      {order.fulfillmentStatus === "SHIPPED" &&
                        order.shippingOption &&
                        order.paymentStatus !== "CANCELLED" && (
                          <div className="mt-2 p-3 bg-gray-50 rounded-lg">
                            <p className="text-sm font-medium text-gray-700">
                              Shipping Method:{" "}
                              {order.shippingOption.shippingMethodName}
                            </p>
                            {order.trackingNumber && (
                              <p className="text-sm text-gray-600">
                                Tracking Number: {order.trackingNumber}
                              </p>
                            )}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Delivered */}
                  <div className="flex">
                    <div className="flex flex-col items-center mr-4">
                      <div
                        className={`w-8 h-8 rounded-full ${
                          order.fulfillmentStatus === "DELIVERED" &&
                          order.paymentStatus !== "CANCELLED"
                            ? "bg-[#82b016]"
                            : "bg-gray-300"
                        } flex items-center justify-center`}
                      >
                        {order.fulfillmentStatus === "DELIVERED" &&
                        order.paymentStatus !== "CANCELLED" ? (
                          <FaCheckCircle className="text-white text-sm" />
                        ) : (
                          <div className="w-3 h-3 rounded-full bg-white"></div>
                        )}
                      </div>
                    </div>
                    <div className="flex-1">
                      <h5 className="font-semibold text-gray-800">
                        {order.paymentStatus === "CANCELLED"
                          ? "Order Cancelled"
                          : order.fulfillmentStatus === "DELIVERED"
                          ? "Delivered"
                          : "Not Delivered Yet"}
                      </h5>
                      <p className="text-gray-600 text-sm">
                        {order.paymentStatus === "CANCELLED"
                          ? "Your order has been cancelled and will not be delivered"
                          : order.fulfillmentStatus === "DELIVERED"
                          ? "Your order has been delivered to the specified address"
                          : "Your order is on its way and will be delivered soon"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Shipping Information */}
              <div className="border-t border-gray-200 pt-6">
                <h4 className="text-lg font-semibold text-gray-700 mb-4">
                  Shipping Information
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <h5 className="font-medium text-gray-800 mb-2">
                      Shipping Address
                    </h5>
                    <p className="text-gray-600">
                      {order.shippingPerson?.name ||
                        order.billingPerson?.name ||
                        `${customer.firstName || ""} ${
                          customer.lastName || ""
                        }`.trim() ||
                        "N/A"}
                    </p>
                    <p className="text-gray-600">
                      {order.shippingPerson?.street ||
                        order.billingPerson?.street ||
                        customer.address1 ||
                        "N/A"}
                    </p>
                    <p className="text-gray-600">
                      {order.shippingPerson?.city ||
                        order.billingPerson?.city ||
                        customer.city ||
                        "N/A"}
                      ,{" "}
                      {order.shippingPerson?.postalCode ||
                        order.billingPerson?.postalCode ||
                        customer.postalCode ||
                        "N/A"}
                    </p>
                    <p className="text-gray-600">
                      {order.shippingPerson?.countryName ||
                        order.billingPerson?.countryName ||
                        customer.country ||
                        "N/A"}
                    </p>
                  </div>

                  {order.shippingOption && (
                    <div>
                      <h5 className="font-medium text-gray-800 mb-2">
                        Shipping Method
                      </h5>
                      <p className="text-gray-600">
                        {order.shippingOption.shippingMethodName}
                      </p>
                      <p className="text-gray-600">
                        Estimated Delivery:{" "}
                        {order.shippingOption.estimatedTransitTime || "N/A"}
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => setShowTrackingModal(false)}
                  className="px-4 py-2 bg-[#82b016] hover:bg-[#6fa010] text-white rounded-lg font-medium transition-colors duration-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderDetails;
